import map from 'lodash/map'
import flatten from 'lodash/flatten'
import { createSelector } from 'reselect'

import {
  getAccountUsers,
} from '@SiteModules/AccountUser/selectors'

export const getAllWorkspaceUsers = createSelector(
  [getAccountUsers],
  (accountUsers) => flatten(map(accountUsers, accountUser => accountUser.workspaceUsers))
)
